<ion-header>
  <ion-toolbar>
    <ion-title>share</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

</ion-content>
